/**
* @ngdoc component
* @name shopcart.component:shopCartHelpCmp
* @description
* Component description
*/
(function() {
  'use strict';

  var shopCartHelpCmp = {
    bindings: {
      shopCart: '<',
      isAuthenticated: '<'
    },
    controller:   shopCartHelpCtrl,
    templateUrl: 'shop-cart-help.component.html'
  };

  angular.module('itxApp.common')
    .component('itxShopCartHelp', shopCartHelpCmp);

  shopCartHelpCtrl.$inject = [
    'ItxShopCartFct',
    'ItxLoaderFct',
    'NavigationService',
    'ItxErrorMessagesFct',
    'SaveForLaterService'
  ];

  function shopCartHelpCtrl (
    ItxShopCartFct,
    ItxLoaderFct,
    NavigationService,
    ItxErrorMessagesFct,
    SaveForLaterService
  ) {
    
    var _this = this;
    
    _this.helpActive = false;
    _this.shopCartError = false;

    _this.$onInit = function () {
      _this.ItxErrorMessagesFct = ItxErrorMessagesFct;
      _this.text = ItxShopCartFct.getMessagesError();
      _this.hasErrors();
      SaveForLaterService.isActive()
        .then(function(buylater){
          _this.showBuylater = buylater.enabled;
        });
    };
    
    _this.$onChanges = function () {
      _this.hasErrors();
    };

    _this.showError = function (error) {
      if(_this.shopCart.state){
        return _this.shopCart.state.errors.indexOf(error) > -1;
      } else {
        return false;
      }
    };

    _this.helpError = function (error) {
        switch (error) {
          case '115':
            _this.deleteItems();
            break;
        }
    };

    _this.deleteItems = function () {
      ItxLoaderFct.show();
      ItxShopCartFct.deleteItemsOutOfStock()
        .finally(function () {
            ItxLoaderFct.hide();
        });  
    };

    _this.hasErrors = function () {
      _this.helpActive = (_this.shopCart.state.errors.length>0);
      if(!_this.helpActive){
        _this.shopCartError = ItxErrorMessagesFct.getLast('shopCartCtrl', 'WARNING');
      }
    };

    _this.goToCart = function () {
      NavigationService.goToShopCartPage();
    };

    _this.helpErrorWishlist = function () {
      ItxLoaderFct.show();
      if(_this.isAuthenticated){
        SaveForLaterService.addArrayItemsList()
        .then(function () {
            ItxLoaderFct.hide();
        });
      } else {
        _this.deleteItems();
      } 
      
    };
    
  }

})();